import { getFetchOptions } from "../../utils";
export function usePaymentApi() {
    return {
        async info(orderId) {
            const response = await fetch('/api/payment_info', getFetchOptions({ order_id: orderId }));
            return await response.json();
        },
        async paymentMethod(paymentId, systemId) {
            let response = await fetch('/api/order/payment_method', getFetchOptions({ paymentId, systemId }, true));
            return await response.json();
        },
        recalculateOrder(paymentId, address, usedBonuses, sameDay) {
            const body = { paymentId, ...(address ? { addressId: address.id, usedBonuses, sameDay } : {}) };
            return fetch('/api/order/recalculate', getFetchOptions(body, true))
                .then(response => response.json());
        }
    };
}
